import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IconName } from '@webapp/core/constants/lucide-icons';
import { InquiryServiceType } from '@webapp/core/enums';
import { PublicInquiryManagerService } from 'projects/webapp/app/services/public-inquiry-manager.service';

interface ServiceCard {
  value: InquiryServiceType;
  icon: IconName;
  title: string;
  text: string;
  cta: string;
}

/** The welcome screen. Picking a service starts its flow right away. */
@Component({
  selector: 'app-inquiry-step1',
  templateUrl: './step1.component.html',
})
export class InquiryStep1Component implements OnInit {
  tenant: string | null = null;

  cards: ServiceCard[] = [
    {
      value: InquiryServiceType.MOVE,
      icon: 'truck',
      title: 'Umzug',
      text: 'Professioneller Umzugsservice in der ganzen Schweiz.',
      cta: 'Umzug anfragen',
    },
    {
      value: InquiryServiceType.CLEAN,
      icon: 'brush',
      title: 'Reinigung',
      text: 'Endreinigung mit Abnahmegarantie durch die Verwaltung.',
      cta: 'Reinigung anfragen',
    },
    {
      value: InquiryServiceType.MOVE_AND_CLEAN,
      icon: 'sparkles',
      title: 'Umzug & Reinigung',
      text: 'Komplettpaket aus einer Hand — meist günstiger als einzeln.',
      cta: 'Komplettpaket anfragen',
    },
  ];

  constructor(
    protected _publicInquiryManagerService: PublicInquiryManagerService,
    protected _route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.tenant = this._route.snapshot.queryParams['tenant'] || null
  }

  start(service: InquiryServiceType): void {
    this._publicInquiryManagerService.submitStep1(service, this.tenant)
  }
}
